<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 20 20"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Style-Guide_Editor2"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      transform="translate(-505.000000, -381.000000)"
    >
      <g
        id="back"
        transform="translate(505.000000, 381.000000)"
        :fill="color"
      >
        <polygon
          id="Shape"
          points="4.75 8.75 11.75 1.75 10 0 0 10 10 20 11.75 18.25 4.75 11.25 20 11.25 20 8.75"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'SvgBackTo',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    },
    width: {
      type: Number,
      default: 15
    },
    height: {
      type: Number,
      default: 15
    }
  }
}
</script>
